import React from 'react';
import { CloseIcon } from '../shared/icons';
import styles from './index.module.scss';

const ConfirmModal = ({ title, message, confirmLabel = 'Delete', cancelLabel = 'Cancel', onConfirm, onCancel, submitting }) => (
  <div className={styles.overlay} onClick={onCancel}>
    <div className={styles.modal} onClick={e => e.stopPropagation()}>
      <div className={styles.header}>
        <span className={styles.title}>{title || 'Confirm Action'}</span>
        <button className={styles.closeBtn} onClick={onCancel}><CloseIcon /></button>
      </div>
      <div className={styles.body}>
        <div className={styles.iconWrap}>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="20" fill="#FEE2E2" />
            <path d="M20 12v9" stroke="#DC2626" strokeWidth="2.2" strokeLinecap="round" />
            <circle cx="20" cy="27" r="1.3" fill="#DC2626" />
          </svg>
        </div>
        <p className={styles.message}>{message}</p>
      </div>
      <div className={styles.footer}>
        <button className={styles.cancelBtn} onClick={onCancel} disabled={submitting}>
          {cancelLabel}
        </button>
        <button className={styles.confirmBtn} onClick={onConfirm} disabled={submitting}>
          {submitting ? 'Deleting...' : confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
